export default "__VITE_ASSET__BPE7L8sA__"